export enum DelegationsTab {
  All = "All",
  ToPay = "ToPay",
  Paid = "Paid",
  Refused = "Refused",
}
